import * as TYPES from './_types';
import * as LEGAL_TYPES from 'views/legal/_types';
import { LOGIN_SUCCESS } from 'views/auth/_types';

const initialState = {};

export default function account(state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_ACCOUNT_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        email: action.payload.email
      };

    case LEGAL_TYPES.ACCEPT_TERMS_SUCCESS:
      return {
        ...state,
        has_accepted_terms: true
      };

    case TYPES.EDIT_ACCOUNT_PHOTO:
      return {
        ...state
      };

    case TYPES.EDIT_ACCOUNT_PHOTO_SUCCESS:
      return {
        ...state,
        photo: action.payload.user.photo
      };

    case TYPES.EDIT_ACCOUNT_SUCCESS:
      return {
        ...state,
        ...action.payload.user
      };
    case LEGAL_TYPES.TERMS_CONFIRM_SUCCESS:
      return {
        ...state,
        ...action.payload.user
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/views/account/_reducer.js